export const OTP_DISABLED =
  process.env.REACT_APP_OTP_DISABLED === "false" ? false : true;
